import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "upgrade"
    }}>{`Upgrade`}</h1>
    <p>{`In this documentation section, we will discuss all the issues you faced if you update from one version to another major version?
Also important update through the Turbo which may cause error will be notified here.`}</p>
    <b> So, please keep the old site backup first for safe migrating approach. </b>
    <div style={{
      "height": "50px"
    }} />
    <hr style={{
      "border": "2px solid gray"
    }} />
    <h3 {...{
      "id": "v900"
    }}>{`v9.0.0`}</h3>
    <pre><code parentName="pre" {...{}}>{`- Inspect latest version support.
- RNB latest version support.
- New theme with Elementor Widget support.
- CSS update.
- Responsive Update.
- Demo data with elementor.
- Turbo Manager plugin add.
- Elementor support apart from product single page
`}</code></pre>
    <p>
  The following video will give you more direct indication. This video will work
  in case of migration from version 8.0.4 or below.
    </p>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/g0DqhtwxqHU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      